import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import "./DashboardTabs.css";
import {
  ContainerHeader,
  Content,
  ContainerWrapper,
  ContainerBody,
} from "../../GridComponent/AdminLte.js";
import Figure from "react-bootstrap/Figure";
import DashboardAnnouncementsList from "../../../components/Dashboard/DashboardAnnouncementsList";
import JobOpenings from "../../../components/Dashboard/JobOpenings";

import {
  Formik,
  FieldArray,
  Field,
  ErrorMessage,
  getIn,
  Form,
  useFormikContext,
} from "formik";
import ShowMore from "react-show-more-list";
import { connect } from "react-redux";
import {
  Container,
  Row,
  Col,
  Table,
  Image,
  Spinner,
  Button,
  Card,
  Tabs,
  Tab,
  Badge,
} from "react-bootstrap";
import PageLoading from "../../../container/PageLoading/PageLoading";
import ChangeLogs from "../../../components/Dashboard/ChangeLogs";
import SummaryDashbord from "../../Summary/SummaryDashbord";
import Authenticator from "../../../services/Authenticator";
import Engagement from "../Engagement/Engagement";
import PoliciesDocumentDownload from "../../PoliciesDocument/PoliciesDocumentDownload";
import CeoCircle from "../CeoCircle";
import OrgChart from "../OrgChart";

/**
 * Tab title with a shorter name for phones and tablets. The full name always stays in the
 * accessibility tree (it is only visually hidden on small screens, see DashboardTabs.css),
 * so screen readers and tests keep reading "Job Opening", not "Jobs".
 */
const TabLabel = ({ long, short }) => (
  <span className={"tab-label" + (short ? " has-short" : "")}>
    <span className="tab-long">{long}</span>
    {short && <span className="tab-short" aria-hidden="true">{short}</span>}
  </span>
);
class DashboardTabs extends Component {
  constructor(props, context) {
    super(props, context);

    this.onTabSelect = this.onTabSelect.bind(this);
    this.defaultTab = this.defaultTab.bind(this);

    this.state = {
      key: "all-announcements",
      summary_shown: false,
      announcement_shown: false,
      engagement_shown: false,
      jobs_shown: false,
      updates_shown: false,
      policies_shown: false,
      coe_shown: false,
      orgchart_shown: false,
    };
    this.stripRef = React.createRef();
  }

  componentWillMount() {}

  componentDidMount(){
    this.nav = this.stripRef.current ? this.stripRef.current.querySelector(".announcement-tabs") : null;
    if (this.nav) {
      this.nav.addEventListener("scroll", this.markOverflow, { passive: true });
      window.addEventListener("resize", this.markOverflow);
      this.markOverflow();
    }
    if (Authenticator.scanLevel(["SubDepartment Head","Department Head","Division Head","DivisionHead","Board","Admin","HR","Payroll"])) {
      this.setState({
      summary_shown: true
    });
    } else {
      this.setState({
        announcement_shown: true
      });
    }
  }
  componentWillUnmount() {
    if (this.nav) {
      this.nav.removeEventListener("scroll", this.markOverflow);
      window.removeEventListener("resize", this.markOverflow);
    }
  }

  // On narrow screens the strip scrolls sideways; a fade on the right edge shows there is more.
  markOverflow = () => {
    const nav = this.nav;
    if (!nav || !this.stripRef.current) return;
    const more = nav.scrollLeft + nav.clientWidth < nav.scrollWidth - 4;
    this.stripRef.current.classList.toggle("has-more", more);
  };

  // Keeps the chosen tab fully in view when the strip is scrolled.
  revealActive = () => {
    const active = this.nav ? this.nav.querySelector(".nav-link.active") : null;
    if (active && typeof active.scrollIntoView === "function") {
      active.scrollIntoView({ block: "nearest", inline: "nearest" });
    }
    this.markOverflow();
  };

  defaultTab = () => {
    if (Authenticator.scanLevel(["SubDepartment Head","Department Head","Division Head","DivisionHead","Board","Admin","HR","Payroll"])) {
      return "evox-summary";
    } else {

      return "all-announcements";
    }
  };
  onTabSelect = (eventKey) => {
    this.setState({
      summary_shown: eventKey == 'evox-summary',
      announcement_shown: eventKey == 'all-announcements',
      engagement_shown: eventKey == 'engagement',
      jobs_shown: eventKey == 'job-openings',
      updates_shown: eventKey == 'evox-updates',
      policies_shown: eventKey == 'policies-download',
      coe_shown: eventKey == 'ceo-circle',
      orgchart_shown: eventKey == 'org-chart'
    }, this.revealActive);
  }
  render() {
    return (
      <div className="dash-tabs" ref={this.stripRef}>
        <Tabs
          defaultActiveKey={
            this.defaultTab()
          }
          id="fill-tab-example"
          className="mb-3 col-9 announcement-tabs"
          fill
          onSelect= { this.onTabSelect }
        >
          {Authenticator.scanLevel(["SubDepartment Head","DivisionHead","Department Head","Board","Admin","HR","Payroll"]) && (
            <Tab
              eventKey="evox-summary"
              title={<TabLabel long="Summary" />}
              tabClassName="newfeature4"
            >
              {this.state.summary_shown && (<SummaryDashbord />)}
            </Tab>
          )}
          {Authenticator.scanLevel(["SubDepartment Head","DivisionHead","Department Head","Board","Admin","HR","Payroll"]) && (
            <Tab
              eventKey="engagement"
              title={<TabLabel long="Engagements" />}
              tabClassName="newfeature6"
            >
              {this.state.engagement_shown && (<Engagement />)}
            </Tab>
          )}
          <Tab
            eventKey="all-announcements"
            title={<TabLabel long="Announcements" />}
            tabClassName="newfeature1"
          >
            {this.state.announcement_shown && (<DashboardAnnouncementsList />)}
          </Tab>
          <Tab
            eventKey="org-chart"
            title={<TabLabel long="Organizational Chart" short="Org chart" />}
            tabClassName="newfeature8"
          >
            {this.state.orgchart_shown && (<OrgChart />)}
          </Tab>
          <Tab
            eventKey="job-openings"
            title={<TabLabel long="Job Opening" short="Jobs" />}
            tabClassName="newfeature2"
          >
            {this.state.jobs_shown && (<JobOpenings />)}
          </Tab>
          <Tab
            eventKey="policies-download"
            title={<TabLabel long="Eastvantage Policies" short="Policies" />}
            tabClassName="newfeature3"
          >
            {this.state.policies_shown && (<PoliciesDocumentDownload />)}
          </Tab>
          <Tab
            eventKey="ceo-circle"
            title={<TabLabel long="CEO Circle of Excellence" short="CEO Circle" />}
            tabClassName="newfeature7"
          >
            {this.state.coe_shown && (<CeoCircle />)}
          </Tab>
          {/* <Tab
            eventKey="evox-updates"
            title="EVOX Updates"
            tabClassName="newfeature3"
          >
            {this.state.updates_shown && (<ChangeLogs />)}
          </Tab> */}

          {/* <Tab eventKey="contact" title="Contact" disabled>
                
              </Tab> */}
        </Tabs>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    // holiday : state.dashboard
    departmentAnnouncement: state.departmentAnnouncement,
  };
};
const mapDispatchToProps = () => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(DashboardTabs);
